var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectBuildingHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 1334,
    viewBox: "0 0 2000 1334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "A28",
    d: "M774.649 204.618H171.004L168.986 285.638H774.649L776.961 288.034H1131.26L1134.23 286.941H1578.56V210.869H1133.85L1129.53 208.325H776.961L774.649 204.618Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "A27",
    d: "M167.197 352.101L168.972 285.648H774.676L776.962 288.04H1131.32L1134.3 286.957L1578.57 286.957L1581.65 350.032H1134.3L1131.32 352.945H777.17L774.637 352.101H167.197Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "A26",
    d: "M170.075 417.654L171.753 352.129H774.678L777.075 352.963H1131.29L1134.3 349.971L1580.2 349.971L1581.47 416.414L1133.33 416.414L1130.39 417.654H777.075H170.075Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "A25",
    d: "M1130.23 482.041H168.046L170.088 417.594H1130.42L1133.33 416.414H1581.46L1583.4 480.439L1134.02 480.439L1130.23 482.041Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "A24",
    d: "M1130.23 546.541L166.565 546.541L168.047 482.095H1130.37L1134.12 480.42H1583.4L1583.77 544.94L1134.02 544.94L1130.23 546.541Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "A23",
    d: "M1130.23 610.929H164.993L166.577 546.482H1130.37L1133.93 544.911L1583.76 544.911L1585.1 609.327L1134.02 609.327L1130.23 610.929Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "A22",
    d: "M1130.53 677.835H162.083L165.145 610.917L1130.53 610.917L1134.08 609.346H1585.05L1586.99 684.421H1134.32L1130.53 677.835Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "A21",
    d: "M1130.52 744.776H160.427L162.108 677.859H1130.52L1134.47 684.355L1586.99 684.356L1604.1 689.578V754.355H1134.47L1130.52 744.776Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectBuildingHotel);
export default __webpack_public_path__ + "static/media/select_building_hotel.b21a6fc4.svg";
export { ForwardRef as ReactComponent };